import useWindowSize from './useWindowSize';

interface IOptions {
  /** 指定容器 */
  wrapElement?: Element | null;
  /** 间隙 */
  clearance?: number;
}

const getElementTop = (element: Element | null | undefined) => {
  const info = element?.getBoundingClientRect?.() || { top: 0 };
  return info.top;
};

const getUnderElementHeight = (element: Element | null) => {
  if (!element) return 0;
  let totalHeight = 0;
  let currentElement: Element | null = element;
  while (currentElement.nextElementSibling) {
    const { height } =
      currentElement.nextElementSibling?.getBoundingClientRect?.() || {
        height: 0,
      };

    totalHeight += height;

    currentElement = currentElement.nextElementSibling;
  }

  // 文本类型需要获取行高来计算入高度
  if (currentElement?.nextSibling) {
    if (typeof window === 'undefined') return totalHeight;

    totalHeight +=
      parseInt(window.getComputedStyle?.(currentElement).lineHeight, 10) || 0;
  }
  return totalHeight;
};

/** 获取填满指定容器的高度(默认填满整个屏幕) */
const useGetFullHeight = (element: Element | null, options: IOptions = {}) => {
  const { wrapElement, clearance = 0 } = options;
  const { height: windowHeight } = useWindowSize({ wait: 200 });
  const elementTop = getElementTop(element);

  // 若指定了父节点，则会计算父节点的底部
  const { bottom: wrapElementbottom } =
    wrapElement?.getBoundingClientRect?.() || { bottom: 0 };

  // 获取后续元素的总高度
  const underElementHeight = getUnderElementHeight(element);

  if (!element) return 0;

  return (
    ((wrapElementbottom || windowHeight) ?? 0) -
    elementTop -
    underElementHeight -
    clearance
  );
};

export default useGetFullHeight;
